var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "match-card-div" }, [
    _c("div", { key: _vm.match.serverId, staticClass: "match-card" }, [
      _vm.match.images && _vm.match.images.length > 0 && _vm.mainImageUrl
        ? _c("img", {
            staticClass: "card-img",
            attrs: { src: _vm.mainImageUrl, alt: "Image de l'match" }
          })
        : _c("img", {
            staticClass: "card-img",
            attrs: {
              src: require("@/assets/images/b122/PLACEHOLDER.png"),
              alt: "Image du match"
            }
          }),
      _vm._v(" "),
      _c("div", { staticClass: "body-match" }, [
        _c(
          "div",
          _vm._l(5, function(index) {
            return _c("i", {
              class:
                (index <= _vm.match.additionnalRewardLevel
                  ? "ph-star-fill"
                  : "ph-star") + " main-color"
            })
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "card-title-match vehicle-name" }, [
          _vm._v(_vm._s(_vm.match.title))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex align-items-center mt-2" }, [
          _c("i", {
            staticClass: "ph-custom ph-clock-counter-clockwise main-color"
          }),
          _vm._v(" "),
          _c("span", { staticClass: "relative-date ml-2" }, [
            _vm._v(
              _vm._s(_vm.convertTimestampToRelativeDate(_vm.match.annonceDate))
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-items-center mb-lg-0 w-100 mt-2" },
          [
            _c("i", { staticClass: "ph-custom ph-map-trifold main-color" }),
            _vm._v(" "),
            _c("span", { staticClass: "relative-date ml-2" }, [
              _vm._v(_vm._s(_vm.getLocation(_vm.match.theftPosition)))
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "not-seen-annonce view-label" }, [
        _c("div", [
          _c("span", { staticClass: "ml-1" }, [
            _vm._v(
              _vm._s(_vm.match.annonceNbViews ? _vm.match.annonceNbViews : "0")
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "svg",
          {
            staticClass: "mr-1",
            attrs: {
              fill: "none",
              height: "19",
              viewBox: "0 0 19 19",
              width: "19",
              xmlns: "http://www.w3.org/2000/svg"
            }
          },
          [
            _c("path", {
              attrs: {
                d:
                  "M18.1595 9.27219C18.1349 9.21664 17.5393 7.89547 16.2153 6.57148C14.4512 4.80734 12.223 3.875 9.7705 3.875C7.318 3.875 5.0898 4.80734 3.32566 6.57148C2.00167 7.89547 1.40331 9.21875 1.38152 9.27219C1.34953 9.34413 1.33301 9.42198 1.33301 9.5007C1.33301 9.57943 1.34953 9.65728 1.38152 9.72922C1.40613 9.78477 2.00167 11.1052 3.32566 12.4292C5.0898 14.1927 7.318 15.125 9.7705 15.125C12.223 15.125 14.4512 14.1927 16.2153 12.4292C17.5393 11.1052 18.1349 9.78477 18.1595 9.72922C18.1915 9.65728 18.208 9.57943 18.208 9.5007C18.208 9.42198 18.1915 9.34413 18.1595 9.27219ZM9.7705 12.3125C9.21424 12.3125 8.67047 12.1475 8.20796 11.8385C7.74545 11.5295 7.38496 11.0902 7.17209 10.5763C6.95922 10.0624 6.90352 9.49688 7.01204 8.95131C7.12056 8.40574 7.38843 7.9046 7.78176 7.51126C8.1751 7.11793 8.67624 6.85006 9.22181 6.74154C9.76738 6.63302 10.3329 6.68872 10.8468 6.90159C11.3607 7.11446 11.8 7.47495 12.109 7.93746C12.4181 8.39997 12.583 8.94374 12.583 9.5C12.583 10.2459 12.2867 10.9613 11.7592 11.4887C11.2318 12.0162 10.5164 12.3125 9.7705 12.3125Z",
                fill: "black"
              }
            })
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "match-infos" }, [
      _c("div", { staticClass: "match-info" }, [
        _c("i", { staticClass: "ph-custom ph-eye-fill main-color" }),
        _vm._v(
          " " +
            _vm._s(_vm.$t("my.matches.vehicle.matched.at")) +
            _vm._s(_vm.convertTimestampToFormatedDate(_vm.match.date)) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "match-info" }, [
        _c("i", { staticClass: "ph-custom ph-map-pin-fill main-color" }),
        _vm._v(" " + _vm._s(_vm.match.address) + "\n    ")
      ]),
      _vm._v(" "),
      _vm.match.status === "FINISHED"
        ? _c("div", { staticClass: "match-info" }, [
            _c("i", {
              staticClass: "ph-custom ph-check-circle-fill validated-color"
            }),
            _vm._v(
              " " +
                _vm._s(_vm.$t("my.matches.vehicle.restitued")) +
                _vm._s(
                  _vm.match.restitutionDate
                    ? _vm.$t("my.matches.the") +
                        _vm.convertTimestampToFormatedDate(
                          _vm.match.restitutionDate
                        )
                    : ""
                ) +
                "\n    "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.match.status === "FINISHED"
        ? _c("div", { staticClass: "match-info" }, [
            _c("i", { staticClass: "ph-custom ph-coins-fill validated-color" }),
            _vm._v(
              " " +
                _vm._s(_vm.match.moneyGained) +
                _vm._s(
                  _vm.match.moneyGained > 1
                    ? _vm.$t("my.matches.money.gained.s")
                    : _vm.$t("my.matches.money.gained")
                ) +
                "\n    "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.match.status === "FINISHED"
        ? _c("div", { staticClass: "match-info" }, [
            _c("i", { staticClass: "ph-custom ph-coins-fill validated-color" }),
            _vm._v(
              " " +
                _vm._s(_vm.match.lampionsGained) +
                " " +
                _vm._s(
                  _vm.match.lampionsGained > 1
                    ? _vm.$t("my.matches.lampion.gained.s")
                    : _vm.$t("my.matches.lampion.gained")
                ) +
                "\n    "
            )
          ])
        : _vm.match.status === "REFUSED" || _vm.match.status === "INVALID"
        ? _c("div", { staticClass: "match-info" }, [
            _c("i", {
              staticClass: "ph-custom ph-x-circle-fill refused-color"
            }),
            _vm._v(" " + _vm._s(_vm.$t("my.matches.match.refused")) + "\n    ")
          ])
        : _c("div", { staticClass: "match-info" }, [
            _c("i", {
              staticClass: "ph-custom ph-hourglass-high-fill hourglass-color"
            }),
            _vm._v(
              " " + _vm._s(_vm.$t("my.matches.to.be.validated")) + "\n    "
            )
          ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9fccdf16", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fccdf16","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/annonce/MatchesCardImage.vue
// module id = QAkH
// module chunks = 0